var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStageDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9324 0.609459C16.4054 0.13018 17.1723 0.13018 17.6453 0.609459C18.1124 1.08286 18.1182 1.84679 17.6625 2.32732L7.98586 13.7659C7.97655 13.7777 7.96661 13.789 7.95608 13.7996C7.48309 14.2789 6.71624 14.2789 6.24326 13.7996L0.354737 7.83272C-0.118246 7.35344 -0.118246 6.57637 0.354737 6.09709C0.82772 5.61781 1.59458 5.61781 2.06756 6.09709L7.06317 11.1592L15.9003 0.646171C15.9103 0.633294 15.921 0.621034 15.9324 0.609459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStageDone);
export default __webpack_public_path__ + "static/media/iconStageDone.5bddd33c9437d9bd782fb635251f2689.svg";
export { ForwardRef as ReactComponent };